"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Mui_1 = require("../../Mui");
const Span_1 = require("../../Span");
/**
 * LoadingButton is modeled after the default https://mui.com/material-ui/api/loading-button/
 * The MUI Labs components are experimental, and may change.
 * Until mui.com converts this to a standard, we can use this component.
 */
function LoadingButton(props) {
    const { isLoading, children, disabled, sx, ...buttonProps } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Button, { ...buttonProps, "aria-disabled": disabled ?? isLoading, disabled: disabled ?? isLoading, sx: (0, Mui_1.mergeSxProps)(sx, isLoading ? { color: "transparent !important" } : undefined), children: [isLoading ? ((0, jsx_runtime_1.jsx)(Span_1.Span, { sx: {
                    position: "absolute",
                    display: "flex",
                    visibility: "visible",
                    left: "50%",
                    transform: "translate(-50%)",
                    color: (theme) => theme.palette.action.disabled,
                }, children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: "24px", color: "inherit" }) })) : null, children] }));
}
exports.LoadingButton = LoadingButton;
//# sourceMappingURL=LoadingButton.js.map